import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {Object}
 */
const defaultProps = {
    viewBoxSize: 48
}

const iconPath = `M39.344 2.47L25.84
   9.224c-.995.497-1.81-.005-1.81-1.117v-4.52c0-1.112-.813-1.615-1.807-1.117L8.716
   9.224c-.994.497-1.808 1.814-1.808 2.925v33.98H41.15l.003-42.544c0-1.11-.815-1.613-1.81-1.116zM21.89
   39.624h-8.562v-8.56h8.56v8.56zm0-14.98h-8.562V16.08h8.56v8.56zm12.785
   14.98H26.17v-8.56h5.88c.352.01.65-.004
   2.625-.025v8.584zm.056-14.98h-8.56V16.08h8.56v8.56z`

/**
 * Stateless function representing a addresses icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <AddressesIcon width={12} />
 */
const AddressesIcon = props => (
    <SvgIcon {...props}>
        <path d={iconPath} />
    </SvgIcon>
)

AddressesIcon.defaultProps = defaultProps

export { AddressesIcon }
